import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateProfileOtherInformationRequest } from './updateProfileOtherInformation.types';

export async function updateProfileOtherInformation(
  data: UpdateProfileOtherInformationRequest
): Promise<void> {
  await axiosInstance.put('/client-profiles/other-information', data);
}
